import {
  Text, Box, Flex,
} from '@chakra-ui/react';
import React, { useCallback, useMemo } from 'react';

import AssignUser from '@app/components/chakra/menus/action/assign-user';

import { QueueRow } from '../types';

interface QueueRowItemProps {
  queueCase: QueueRow;
  onAssignUser: (queueCase: QueueRow, newOperatorId: string) => void;
}

const QueueRowItem: React.FC<QueueRowItemProps> = ({ queueCase, onAssignUser }) => {
  const handleAssignUser = useCallback((e: string) => {
    onAssignUser(queueCase, e);
  }, [queueCase, onAssignUser]);

  const formattedWaitTime = useMemo(() => (
    <>
      <Text as="span" fontWeight="bold">{queueCase.waitTime}</Text>
      {' '}
      <Text as="span" fontSize="xs">min</Text>
    </>
  ), [queueCase.waitTime]);

  return (
    <Flex
      width="100%"
      borderBottom="1px solid"
      borderColor="gray.100"
      _hover={{ bg: 'gray.50' }}
      minHeight="60px"
      alignItems="center"
    >
      {/* Wait Time Column */}
      <Box
        width="100px"
        px={3}
        textAlign="center"
      >
        <Text fontSize="sm" color="gray.600">
          {formattedWaitTime}
        </Text>
      </Box>

      {/* Customer Name Column */}
      <Box
        width="180px"
        px={3}
      >
        <Text
          fontSize="sm"
          color="gray.600"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {queueCase.customerName}
        </Text>
      </Box>

      {/* Message Column */}
      <Box
        flex="1"
        px={3}
        py={2}
        maxH="60px"
        overflow="hidden"
      >
        <Text
          fontSize="sm"
          color="gray.600"
          lineHeight="1.2"
          maxHeight="2.4em"
          overflow="hidden"
          textOverflow="ellipsis"
          css={{
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {queueCase.lastMessage}
        </Text>
      </Box>

      {/* Assign Column */}
      <Box
        width="180px"
        px={3}
        position="relative"
        zIndex="dropdown"
      >
        <AssignUser
          id="assign-queue-user"
          defaultLabel="Assign to..."
          rowId={`assign-queue-case-${queueCase._id}`}
          selectedId={queueCase.operatorId || 'unassigned'}
          handleSelect={handleAssignUser}
          matchWidth
          size="sm"
        />
      </Box>
    </Flex>
  );
};

export default QueueRowItem;
